import { AfterViewInit, Component, inject, Input, ViewChild } from '@angular/core'
import { PdfJsViewerComponent, PdfJsViewerModule } from 'ng2-pdfjs-viewer'
import { dataUriToBlob } from 'src/app/services/utils'
import { IonicModule, ModalController } from '@ionic/angular'
import { TranslocoModule } from '@jsverse/transloco'

@Component({
  selector: 'app-pdf-viewer',
  standalone: true,
  imports: [PdfJsViewerModule, IonicModule, TranslocoModule],
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
})
export class PdfViewerComponent implements AfterViewInit {
  private readonly modalCtrl = inject(ModalController)

  @Input() src: string

  @ViewChild('pdfViewer') pdfViewer: PdfJsViewerComponent

  async ngAfterViewInit() {
    if (!this.src) return
    this.pdfViewer.pdfSrc = await dataUriToBlob(this.src)
    this.pdfViewer.refresh()
  }

  dismiss(): void {
    void this.modalCtrl.dismiss()
  }
}
